import type { ReactElement } from 'react';
import { Box } from '@mantine/core';
import type { TurnTone } from './PolicyVerdict';

const TURN_TONE_FG: Record<TurnTone, string> = {
    danger: 'var(--bm-color-danger-text)',
    caution: 'var(--bm-color-caution-text)',
    neutral: 'var(--bm-color-text-dimmed)',
};

/** A monospace chip rendering a policy's illustrative verdict, colored by magnitude. */
export default function PolicyOutputChip({ output, tone }: { output: string; tone: TurnTone }): ReactElement {
    return (
        <Box
            component="span"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                padding: '1px 8px',
                borderRadius: 6,
                fontFamily: 'monospace',
                fontWeight: 700,
                fontSize: 12,
                whiteSpace: 'nowrap',
                color: TURN_TONE_FG[tone],
                background: 'var(--bm-color-surface-alt)',
                border: '1px solid var(--bm-color-border)',
            }}
        >
            {output}
        </Box>
    );
}
